import ResetPassword from "./components";

export default ResetPassword